(() => {
  if (customElements.get('explore-menu')) return;

  class ExploreMenu extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-explore-col]').forEach((col) => {
        const img = col.querySelector('[data-explore-img]');
        if (!img) return;

        const defaultSrc = img.getAttribute('data-default') || img.getAttribute('src');

        col.querySelectorAll('[data-explore-image]').forEach((link) => {
          const src = link.getAttribute('data-explore-image');
          link.addEventListener('pointerenter', () => this.swap(img, src));
          link.addEventListener('focus', () => this.swap(img, src));
        });

        col.addEventListener('pointerleave', () => this.swap(img, defaultSrc));
      });
    }

    /**
     * Preloads the incoming image before swapping so the slot never flashes empty.
     */
    swap(img, src) {
      if (!src || img.dataset.pending === src || img.getAttribute('src') === src) return;

      img.dataset.pending = src;

      const preload = new Image();
      preload.onload = () => {
        // Bail if the pointer moved on to something else while this was loading.
        if (img.dataset.pending !== src) return;
        img.setAttribute('src', src);
      };
      preload.src = src;
    }
  }

  customElements.define('explore-menu', ExploreMenu);
})();